import api from '../../lib/api';
import {
  url_api_v1_sb_profile_media_request_create,
  url_api_v1_sb_profile_media_request_delete,
  url_api_v1_sb_profile_media_request_get,
  url_api_v1_sk_doc_add,
  url_api_v1_sk_doc_remove,
  url_api_v1_sk_search_get,
} from '../../lib/apiUrl';
import {
  SbProfilesMediaModel,
  SubmissionKitDocumentModel,
} from '../submission_kits/components/KitModels';

class SbProfilesMediaService {
  getBySubmissionBoard = async (project_uuid: string, sb_id: number) => {
    try {
      const url = url_api_v1_sb_profile_media_request_get
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting submission kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  create = async (
    project_uuid: string,
    sb_id: number,
    kit_document_id: any,
    media_status: number,
    tag: string
  ) => {
    try {
      const url = url_api_v1_sb_profile_media_request_create
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sb_id.toString());
      const response = await api.post(url, {
        kit_document_id: kit_document_id,
        media_status: media_status,
        tag: tag,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in adding media in submission kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  delete = async (project_uuid: string, sbProfilesMedia: SbProfilesMediaModel) => {
    try {
      const url = url_api_v1_sb_profile_media_request_delete
        .replace(':project_uuid', project_uuid)
        .replace(':sb_id', sbProfilesMedia.submission_board_id.toString())
        .replace(':sb_profiles_media_id', sbProfilesMedia.id.toString());
      const response = await api.delete(url, {});
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error creating job.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
}

const sbProfilesMediaService = new SbProfilesMediaService();

export default sbProfilesMediaService;
